// angular
import { Component, Input, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MeRegisterService } from '../../register/me-register.service';
import { AppService } from '../../../app.service';

@Component({
    selector: 'me-set-password',
    templateUrl: './set-password.component.html',
    styleUrls: ['./set-password.component.scss']
})

export class MeSetPasswordComponent implements OnInit {
    form: FormGroup;
    submitted = false;
    hidePassword = false;
    errorMessage = '';
    @Input() verifyToken = '';

    constructor(
        public appService: AppService,
        public meRegisterService: MeRegisterService,
        public fb: FormBuilder
    ) {

    }

    ngOnInit() {
        this.form = this.fb.group({
            password: ['', [Validators.required, Validators.minLength(8)]],
        });
    }

    submit(data, isValid) {
        this.submitted = true;
        if (!isValid) {
            return;
        }

        this.appService.isLoading = true;
        this.meRegisterService.verify({
            token : this.verifyToken,
            password : data.password
        }).subscribe((res) => {
            this.meRegisterService.step = 7;
            this.appService.isLoading = false;
            this.meRegisterService.patientPassword = data.password;
            this.meRegisterService.patientEmail = res['email'];
        },
        (error) => {
            this.errorMessage = error.error.error;
            this.appService.isLoading = false;
        });
    }
}
